import { Controller } from "stimulus"

// #1978: het venster dat om de reden voor Lost vraagt. Opent zichzelf zodra de
// server het stuurt, ook boven het grote venster van een kaart.
export default class extends Controller {
  connect() {
    this.element.showModal()
    this.element.querySelector("input[type='text']")?.focus()
  }

  sluit() {
    this.element.close()
  }

  weg() {
    this.element.remove()
  }
}
